
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11 1.375a9.625 9.625 0 100 19.25 9.625 9.625 0 000-19.25zm0 17.875a8.25 8.25 0 110-16.5 8.25 8.25 0 010 16.5z","fill":"#fff"}}),_c('path',{attrs:{"d":"M9.199 13.468l-2.262-2.269-.976.976 2.289 2.262a1.375 1.375 0 00.976.4c.354-.008.691-.15.942-.4l5.871-5.87-.976-.97-5.864 5.87z","fill":"#fff"}})])
          )
        }
      }
    